
import Vue from 'vue'
import router from './router.js'
import eventHub from '../mixins/eventHub'
import Support from '../utils/global/Support.js'
import Scroll from '../utils/dom/Scroll.js'
import Sound from '../utils/media/Sound.js'




/*
import Stats from 'stats.js'
const stats = new Stats()
stats.showPanel( 0 ) // 0: fps, 1: ms, 2: mb, 3+: custom
document.body.appendChild( stats.dom )
*/



let firstPage = true


export default {

    // render: h => h(Application),
    router,
    // el: '#application',

    watch: {

        '$route' (to, from) {
            this._onRouteChange(to,from)
        }
    },

    data()
    {
        return {

            componentId: null,
            currentPage: null,
            content: {},

            time: 0,
            windowSize: [0, 0],
            support: new Support(),
            height: 0,

            showMenu: false,
            menuIsOpened: false,
            /*menuTransitionEnter: function (el, done) {
                setTimeout(done, 2000)
            },
            menuTransitionLeave: function (el, done) {
                setTimeout(done, 1700)
            },*/

            subscribeEnable: true,
            popinWatchEnable: false,

            pageHasSound: false,
            muted: false
        }
    },

    created()
    {
        this.scroll = new Scroll()
        this.windowSize = [document.body.clientWidth, window.innerHeight]
        this.time = Date.now()

        window.addEventListener('resize', this._onResize.bind(this), false)



        this.eventHub.$on('ajax:success', this._onDataSuccess.bind(this))
        this.eventHub.$on('ajax:error', this._onDataError.bind(this))
        this.eventHub.$on('page:loaded', this._onPageLoaded.bind(this))
        this.eventHub.$on('menu:toggle', this.toggleMenu.bind(this))



        this.eventHub.$on('popin:watch:open', this._onPopinWatchOpen.bind(this))
        this.eventHub.$on('popin:watch:close', this._onPopinWatchClose.bind(this))


        this.muted = this.support.touch
        this._sound = new Sound('/assets/sound/intro-home.mp3')
        // Active direct play/pause if mobile
        this._sound.transitionDisable = this.support.touch
    },

    mounted()
    {
        // console.log('%c 0 days off' + '%c by IMMERSIVE GARDEN', 'background: #edeee9; color: #1d2128; font-size: x-large; border-radius: 6px', 'color: #1d2128; font-size: x-small')
        console.log('%c0 days off ' + '%cwebsite by IMMERSIVE GARDEN', 'color: #a1895f; font-size: x-large;', 'color: #d3d3d2; font-size: x-small; font-style: italic;')

        // this._disableThreeJsLogs()

        if (!(('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0)))
        {
            document.body.classList.add('is-desktop')
        }

        this._onRouteChange(this.$route)
        this._enterFrame(0)
        Vue.nextTick(this._onResize.bind(this, null, true))


        // Force display menu for dev
        // setTimeout(this.toggleMenu, 1000)
    },

    methods: {

        /*_disableThreeJsLogs()
        {
            // Disable all log (ThreeJs include)
            const realLog = console.log
            console.log = (...log) => {

                if (log.length > 1 && typeof log[0] == 'string' && log[0].search('THREE') > -1)
                {
                    return
                }
                else
                {
                    realLog(...log)
                }
            }
        },*/

        _onPopinWatchOpen()
        {
            this.popinWatchEnable = true
            this._checkSound()
        },

        _onPopinWatchClose()
        {
            this.popinWatchEnable = false
            this._checkSound()
        },


        /*
                ┌─────────────────────────────────────────────
                │
                │       PUBLIC METHODS
                │
                └─────────────────────────────────────────────
        */

        toggleMute()
        {
            this.muted = !this.muted
            this._checkSound()
        },

        _checkSound()
        {
            if (this.pageHasSound && !this.muted && !this.popinWatchEnable)
            {
                this._sound.play(6000)
            }
            else
            {
                this._sound.pause(1000)
            }
        },

        scrollTo( x, y )
        {
            window.scrollTo(x, y)
        },

        loadPage( location )
        {
            router.push( location )
        },


        /*
                ┌─────────────────────────────────────────────
                │
                │       SCROLLBAR
                │
                └─────────────────────────────────────────────
        */

        removeScrollbar()
        {
            if (!this._scrollData)
            {
                this._scrollData = []
            }

            this._scrollData.push({
                scroll: [ 0, this.scroll.realY ],
                pageHeight: this.height
            })

            // console.log('rm scrollbar', this._scrollData.length)
            this.setHeight(-1)
        },

        deliverScrollbar()
        {

            if (!this._scrollData)
            {
                this._scrollData = []
            }

            if (this._scrollData.length < 1)
            {
                console.error('You can\'t add a scrollbar if it was not removed before')
                return
            }

            const scrollData = this._scrollData.pop()

            this.setHeight(scrollData.pageHeight)
            this._resetScroll(...scrollData.scroll)

            // console.log('add scrollbar', this._scrollData.length)
        },

        _resetScroll( x, y )
        {
            if (!this._scrollData)
            {
                this._scrollData = []
            }

            if (this._scrollData.length > 0)
            {
                const scrollData = this._scrollData[this._scrollData.length - 1]
                scrollData.scroll = [0, 0]
            }

            this.scroll.reset( y )
            this.scrollTo( x, y )
            this.scroll.update( 1/60, true )
        },

        setHeight( height )
        {
            // fake scroll
            if (height > 0)
            {
                this.height = height
                this.$el.style.height = height + 'px'
            }
            // real scroll (mobile) or no scroll
            else
            {
                this.$el.style.height = ''
                this.height = this.$el.offsetHeight
                this.$el.style.height = '100vh'
                // this.$el.style.overflow = 'auto'
            }

            this.scroll.resizePage( this.height )
        },


        /*
                ┌─────────────────────────────────────────────
                │
                │       MENU
                │
                └─────────────────────────────────────────────
        */

        toggleMenu()
        {
            this.showMenu = !this.showMenu
            if (this.showMenu)
            {
                this.$el.classList.add('is-menu-open')
            }
            else
            {
                this.$el.classList.remove('is-menu-open')
            }
        },

        _onMenuOpen()
        {
            this.menuIsOpened = true
            this.removeScrollbar()
        },

        _onMenuLeave()
        {
            this.menuIsOpened = false
            this.deliverScrollbar()
        },

        _onResize( event, force = false )
        {
            const OPTIMIZE_PHONE = false
            const OPTIMIZE_REFRESH = true

            const now = Date.now()
            if (OPTIMIZE_REFRESH)
            {
                clearTimeout(this._resizedTo)

                if (force || (this._lastResized && now - this._lastResized > 299))
                {
                    const w = document.body.clientWidth // window.innerWidth
                    const h = window.innerHeight
                    const oldW = this.windowSize[0]
                    const oldH = this.windowSize[1]

                    // prevent smartphone scroll
                    if (OPTIMIZE_PHONE && w !== oldW || (Math.abs(h - oldH) > 100 || h > oldH) )
                    {
                        this._dispatchResize(w, h)
                    }
                    else
                    {
                        this._dispatchResize(w, h)
                    }
                }
                else
                {
                    this._resizedTo = setTimeout(this._onResize.bind(this), 300)
                }
            }
            else
            {
                const w = document.body.clientWidth // window.innerWidth
                const h = window.innerHeight
                this._dispatchResize(w, h)
            }

            this._lastResized = now
        },

        _dispatchResize(w, h)
        {
            this.windowSize[0] = w
            this.windowSize[1] = h
            this.eventHub.$emit('window:resized', w, h)

            this.scroll.resizeWindow( h )
        },

        _enterFrame()
        {
            const time = Date.now()
            const dt = Math.min(time - this.time, 500)
            this.time = time

            this.scroll.update(dt)

            this.eventHub.$emit('enterFrame', dt)

            requestAnimationFrame(this._enterFrame)
        },



        /*
                ┌─────────────────────────────────────────────
                │
                │       ROUTES & LOADER
                │
                └─────────────────────────────────────────────
        */

        _onPageLoaded()
        {
            this.$el.classList.remove('is-loading')
            this.$el.classList.add('is-ready')
        },

        _onRouteChange( to, from )
        {
            if (firstPage && to.name === 'page-home')
            {
                return this.loadPage('/')
            }

            firstPage = false

            if (this.$el)
            {
                this.$el.classList.add('is-loading')
                this.$el.classList.remove('is-ready')
            }
            setTimeout( this._changePage.bind(this), 1000, to )

            if (to.meta.sound === 1)
            {
                this.pageHasSound = true
                this._checkSound()
            }
            else
            {
                this.pageHasSound = false
                this._checkSound()
            }

            this.eventHub.$emit('page:change', to.path)
        },

        _changePage( to )
        {
            this._resetScroll( 0, 0 )

            this.setHeight(-1)
            this.componentId = to.name
            this.currentPage = to.path


            // Google Analytics tracking
            document.title = '0 days off - ' + to.meta.title
            ga('set', { page: to.path, title: to.meta.title })
            ga('send', 'pageview')

            if (to.meta.bgLight)
            {
                this.$el.classList.add('is-bg-light')
            }
            else
            {
                this.$el.classList.remove('is-bg-light')
            }

            if (this.showMenu)
            {
                this.toggleMenu()
            }
        },

        /*_gaInit( i, s, g, r, a, m )
        {
            i['GoogleAnalyticsObject'] = r

            i[r] = i[r] || function() {
                (i[r].q = i[r].q || []).push(arguments)
            },
            i[r].l = 1 * new Date()

            a = s.createElement('script'),
            m = s.getElementsByTagName('div')[0]

            a.async = 1

            a.src = g

            m.parentNode.insertBefore(a, m)
        },

        _ga()
        {
            this._gaInit(window, document, 'https://www.google-analytics.com/analytics.js', 'ga')

            ga('create', 'UA-88914851-2', 'auto');
            ga('send', 'pageview');
        },*/


        /*
                ┌─────────────────────────────────────────────
                │
                │       JSON DATAS
                │
                └─────────────────────────────────────────────
        */

        _onDataSuccess( resp )
        {
            this.content = resp.body
        },

        _onDataError( err )
        {
            console.warn('onDataError', err)
        }
    }
}
